<template>
  <div class="episode-list-wrap">
    <div class="episode-list">
      <div
        v-for="item in episodeList"
        :key="item.episodeNo"
        class="episode-item"
        :data-episode-no="item.episodeNo"
      >
        <div
          class="episode-item-header"
          @click="toggleEpisode(item.episodeNo)"
        >
          <Icon
            type="md-arrow-dropright"
            :size="20"
            class="episode-item-arrow"
            :class="{ 'episode-item-arrow--expanded': isEpisodeExpanded(item.episodeNo) }"
          />
          <span class="episode-item-title">
            第{{ item.episodeNo }}集 · {{ item.title }}
          </span>
        </div>
        <div
          v-show="isEpisodeExpanded(item.episodeNo)"
          class="episode-item-body"
        >
          <Row :gutter="48" type="flex" align="top" class="episode-form-row">
            <Col :span="12">
              <div class="episode-field episode-field--cell">
                <div class="episode-field-label">
                  单集标题
                  <span v-if="editable" class="episode-required">*</span>
                </div>
                <div
                  class="episode-field-control"
                  :class="{
                    'episode-field-control--error': !!getEpisodeFieldError(
                      item.episodeNo,
                      'title'
                    )
                  }"
                >
                  <Input
                    v-if="editable"
                    v-model="item.title"
                    placeholder="请输入单集标题"
                    @on-blur="handleEpisodeFieldBlur(item, 'title')"
                    @on-change="handleEpisodeFieldInput(item, 'title')"
                  />
                  <div v-else class="episode-field-value">{{ item.title }}</div>
                  <div
                    v-if="editable && getEpisodeFieldError(item.episodeNo, 'title')"
                    class="episode-field-error-tip"
                  >
                    {{ getEpisodeFieldError(item.episodeNo, 'title') }}
                  </div>
                </div>
                <div v-if="editable" class="episode-field-actions">
                  <span class="episode-field-actions-placeholder" aria-hidden="true" />
                </div>
              </div>
            </Col>
            <Col :span="12">
              <div class="episode-field episode-field--cell">
                <div class="episode-field-label">
                  单集封面
                  <span v-if="editable" class="episode-required">*</span>
                </div>
                <div
                  class="episode-field-control"
                  :class="{
                    'episode-field-control--error': !!getEpisodeFieldError(
                      item.episodeNo,
                      'coverUrl'
                    )
                  }"
                >
                  <Input
                    v-if="editable"
                    v-model="item.coverUrl"
                    placeholder="请输入或上传封面地址"
                    @on-blur="handleEpisodeFieldBlur(item, 'coverUrl')"
                    @on-change="handleEpisodeFieldInput(item, 'coverUrl')"
                  />
                  <div v-else class="episode-field-value episode-field-value--file">
                    {{ displayFileLabel(item.coverUrl) }}
                  </div>
                  <div
                    v-if="editable && getEpisodeFieldError(item.episodeNo, 'coverUrl')"
                    class="episode-field-error-tip"
                  >
                    {{ getEpisodeFieldError(item.episodeNo, 'coverUrl') }}
                  </div>
                </div>
                <div v-if="editable" class="episode-field-actions">
                  <Button
                    type="primary"
                    ghost
                    class="episode-upload-btn"
                    @click="handleSelectFile(item.episodeNo, 'coverUrl')"
                  >
                    选择替换文件
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          <Row :gutter="48" type="flex" align="top" class="episode-form-row">
            <Col :span="12">
              <div class="episode-field episode-field--cell">
                <div class="episode-field-label">
                  {{ editable ? '无字幕原片视频' : '当前送审视频' }}
                  <span v-if="editable" class="episode-required">*</span>
                </div>
                <div
                  class="episode-field-control"
                  :class="{
                    'episode-field-control--error': !!getEpisodeFieldError(
                      item.episodeNo,
                      'videoUrl'
                    )
                  }"
                >
                  <Input
                    v-if="editable"
                    v-model="item.videoUrl"
                    placeholder="请输入或上传视频地址"
                    @on-blur="handleEpisodeFieldBlur(item, 'videoUrl')"
                    @on-change="handleEpisodeFieldInput(item, 'videoUrl')"
                  />
                  <div v-else class="episode-field-value episode-field-value--file">
                    {{ displayFileLabel(item.videoUrl) }}
                  </div>
                  <div
                    v-if="editable && getEpisodeFieldError(item.episodeNo, 'videoUrl')"
                    class="episode-field-error-tip"
                  >
                    {{ getEpisodeFieldError(item.episodeNo, 'videoUrl') }}
                  </div>
                </div>
                <div v-if="editable" class="episode-field-actions">
                  <Button
                    type="primary"
                    ghost
                    class="episode-upload-btn"
                    @click="handleSelectFile(item.episodeNo, 'videoUrl')"
                  >
                    选择替换文件
                  </Button>
                </div>
              </div>
            </Col>
            <Col v-if="editable && item.subtitleLangSlots[0]" :span="12">
              <div class="episode-field episode-field--cell">
                <div class="episode-field-label">
                  {{ item.subtitleLangSlots[0].languageName }}外挂字幕
                  <span
                    v-if="item.subtitleLangSlots[0].required"
                    class="episode-required"
                  >*</span>
                  <span v-else class="episode-label-optional">（可选）</span>
                </div>
                <div
                  class="episode-field-control"
                  :class="{
                    'episode-field-control--error': !!getEpisodeFieldError(
                      item.episodeNo,
                      subtitleSlotFieldKey(item.subtitleLangSlots[0])
                    )
                  }"
                >
                  <Input
                    v-model="item.subtitleLangSlots[0].subtitleUrl"
                    placeholder="请输入或上传字幕地址"
                    @on-blur="
                      handleEpisodeFieldBlur(
                        item,
                        subtitleSlotFieldKey(item.subtitleLangSlots[0])
                      )
                    "
                    @on-change="
                      handleEpisodeFieldInput(
                        item,
                        subtitleSlotFieldKey(item.subtitleLangSlots[0])
                      )
                    "
                  />
                  <div
                    v-if="
                      getEpisodeFieldError(
                        item.episodeNo,
                        subtitleSlotFieldKey(item.subtitleLangSlots[0])
                      )
                    "
                    class="episode-field-error-tip"
                  >
                    {{
                      getEpisodeFieldError(
                        item.episodeNo,
                        subtitleSlotFieldKey(item.subtitleLangSlots[0])
                      )
                    }}
                  </div>
                </div>
                <div class="episode-field-actions">
                  <Button
                    type="primary"
                    ghost
                    class="episode-upload-btn"
                    @click="
                      handleSelectFile(
                        item.episodeNo,
                        subtitleSlotFieldKey(item.subtitleLangSlots[0])
                      )
                    "
                  >
                    选择替换文件
                  </Button>
                </div>
              </div>
            </Col>
            <Col v-else-if="editable" :span="12" />
            <Col v-else-if="item.subtitleList[0]" :span="12">
              <div class="episode-field episode-field--cell">
                <div class="episode-field-label">
                  {{ item.subtitleList[0].languageName }}外挂字幕
                  <span
                    v-if="item.subtitleList[0].required"
                    class="episode-required"
                  >*</span>
                  <span v-else class="episode-label-optional">（可选）</span>
                </div>
                <div class="episode-field-control">
                  <div class="episode-field-value episode-field-value--file">
                    {{ displaySubtitleValue(item.subtitleList[0].subtitleUrl) }}
                  </div>
                </div>
              </div>
            </Col>
            <Col v-else :span="12" />
          </Row>

          <template v-if="!editable">
            <Row
              v-for="(sub, subIndex) in item.subtitleList.slice(1)"
              :key="`${item.episodeNo}-subtitle-${subIndex + 1}`"
              :gutter="48"
              type="flex"
              align="top"
              class="episode-form-row"
            >
              <Col :span="12">
                <div class="episode-field episode-field--cell">
                  <div class="episode-field-label">
                    {{ sub.languageName }}外挂字幕
                    <span v-if="sub.required" class="episode-required">*</span>
                    <span v-else class="episode-label-optional">（可选）</span>
                  </div>
                  <div class="episode-field-control">
                    <div class="episode-field-value episode-field-value--file">
                      {{ displaySubtitleValue(sub.subtitleUrl) }}
                    </div>
                  </div>
                </div>
              </Col>
              <Col :span="12" />
            </Row>
            <Row
              v-if="!item.subtitleList.length"
              :gutter="48"
              type="flex"
              align="top"
              class="episode-form-row"
            >
              <Col :span="12">
                <div class="episode-field episode-field--cell">
                  <div class="episode-field-label">外挂字幕</div>
                  <div class="episode-field-control">
                    <div class="episode-field-value">—</div>
                  </div>
                </div>
              </Col>
              <Col :span="12" />
            </Row>
          </template>

          <template v-if="editable">
            <Row
              v-for="(slot, subIdx) in item.subtitleLangSlots.slice(1)"
              :key="`${item.episodeNo}-edit-subtitle-${subIdx + 1}-${slot.langId || slot.language}`"
              :gutter="48"
              type="flex"
              align="top"
              class="episode-form-row"
            >
              <Col :span="12">
                <div class="episode-field episode-field--cell">
                  <div class="episode-field-label">
                    {{ slot.languageName }}外挂字幕
                    <span v-if="slot.required" class="episode-required">*</span>
                    <span v-else class="episode-label-optional">（可选）</span>
                  </div>
                  <div
                    class="episode-field-control"
                    :class="{
                      'episode-field-control--error': !!getEpisodeFieldError(
                        item.episodeNo,
                        subtitleSlotFieldKey(slot)
                      )
                    }"
                  >
                    <Input
                      v-model="slot.subtitleUrl"
                      placeholder="请输入或上传字幕地址"
                      @on-blur="
                        handleEpisodeFieldBlur(
                          item,
                          subtitleSlotFieldKey(slot)
                        )
                      "
                      @on-change="
                        handleEpisodeFieldInput(
                          item,
                          subtitleSlotFieldKey(slot)
                        )
                      "
                    />
                    <div
                      v-if="
                        getEpisodeFieldError(
                          item.episodeNo,
                          subtitleSlotFieldKey(slot)
                        )
                      "
                      class="episode-field-error-tip"
                    >
                      {{
                        getEpisodeFieldError(
                          item.episodeNo,
                          subtitleSlotFieldKey(slot)
                        )
                      }}
                    </div>
                  </div>
                  <div class="episode-field-actions">
                    <Button
                      type="primary"
                      ghost
                      class="episode-upload-btn"
                      @click="
                        handleSelectFile(
                          item.episodeNo,
                          subtitleSlotFieldKey(slot)
                        )
                      "
                    >
                      选择替换文件
                    </Button>
                  </div>
                </div>
              </Col>
              <Col :span="12" />
            </Row>
          </template>
        </div>
      </div>
    </div>
    <input
      ref="episodeFileInput"
      type="file"
      class="episode-file-input"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import { resolveSubtitleTabLabel } from '@/utils/subtitleLanguageLabel'
import { uploadReviewMaterialFile } from '../../utils/reviewFileUpload'

/** 统一语言码：en_US / en-US → en-us，便于按主语言前缀匹配 */
function normalizeLanguageCode(code) {
  return String(code || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
}

function pickPositiveInt(value) {
  const n = Number(value)
  if (value == null || value === '' || Number.isNaN(n) || n <= 0) {
    return null
  }
  return n
}

function isEnglishLanguage(language) {
  const code = normalizeLanguageCode(language)
  return code === 'en' || code.startsWith('en-')
}

/** 接口 subtitles[] 上的 language（如 en-us、de-de） */
function readSubtitleLanguageCode(sub) {
  if (!sub) return ''
  return String(sub.language || sub.langCode || sub.lang || '').trim()
}

/** 识别英语轨：language 为 en-us 等，或 languageName 为「英语」 */
function isEnglishSubtitleLang(sub) {
  if (!sub) return false
  if (isEnglishLanguage(readSubtitleLanguageCode(sub))) return true
  const name = String(sub.languageName || '')
    .trim()
    .toLowerCase()
  if (name === '英语' || name === 'english') return true
  const display = resolveSubtitleDisplayName(sub)
  return display === '英语'
}

function resolveSubtitleDisplayName(sub) {
  const language = readSubtitleLanguageCode(sub)
  const fromMap = resolveSubtitleTabLabel({
    language,
    languageName: sub && sub.languageName
  })
  if (fromMap && fromMap !== '——') return fromMap
  const name = (sub && sub.languageName && String(sub.languageName).trim()) || ''
  if (name) return name
  return language || '—'
}

function normalizeSubToLangDef(sub) {
  const language = readSubtitleLanguageCode(sub)
  // 业务规则：仅英语（en-us 等）外挂字幕必填；de-de 等其它语言标注可选
  return {
    language,
    languageName: resolveSubtitleDisplayName(sub),
    langId: sub && sub.langId,
    required: isEnglishSubtitleLang(sub)
  }
}

function normalizeLanguageDefList(list) {
  return (list || []).map((item) => normalizeSubToLangDef(item))
}

function deriveLanguageDefsFromEpisodes(episodes) {
  const eps = episodes || []
  if (!eps.length) return []
  const map = new Map()
  const orderedKeys = []
  const appendDef = (sub) => {
    const def = normalizeSubToLangDef(sub)
    const key =
      pickPositiveInt(def.langId) ||
      normalizeLanguageCode(def.language) ||
      def.languageName
    if (!key || map.has(key)) return
    map.set(key, def)
    orderedKeys.push(key)
  }
  // 顺序与接口 episodes[].subtitles 一致（如先 en-us 再 de-de）
  eps.forEach((ep) => {
    ;(ep.subtitles || []).forEach(appendDef)
  })
  return orderedKeys.map((key) => map.get(key))
}

/** 从 materials 根字段或各集 subtitles 推导外挂字幕语言配置 */
export function extractSubtitleLanguageDefs(materialsRaw) {
  if (!materialsRaw) return []
  const album = materialsRaw.album || {}
  const candidates = [
    materialsRaw.subtitleLanguages,
    materialsRaw.subtitleLangList,
    materialsRaw.subtitleLanguageList,
    album.subtitleLanguages,
    album.subtitleLangList
  ]
  for (let i = 0; i < candidates.length; i += 1) {
    const list = candidates[i]
    if (Array.isArray(list) && list.length) {
      return normalizeLanguageDefList(list)
    }
  }
  return deriveLanguageDefsFromEpisodes(materialsRaw.episodes)
}

function findSubtitleInEpisode(subtitles, def) {
  const langId = pickPositiveInt(def && def.langId)
  if (langId) {
    const byId = (subtitles || []).find(
      (sub) => Number(sub.langId) === langId
    )
    if (byId) return byId
  }
  const prefix = normalizeLanguageCode(def && def.language)
  if (!prefix) return null
  return (subtitles || []).find((sub) => {
    const code = normalizeLanguageCode(readSubtitleLanguageCode(sub))
    if (!code || !prefix) return false
    if (code === prefix) return true
    if (code.startsWith(`${prefix}-`) || prefix.startsWith(`${code}-`)) return true
    const codePrimary = code.split('-')[0]
    const prefixPrimary = prefix.split('-')[0]
    return codePrimary.length >= 2 && codePrimary === prefixPrimary
  })
}

function buildSubtitleLangSlots(ep, languageDefs) {
  const subtitles = ep.subtitles || []
  if (Array.isArray(languageDefs) && languageDefs.length) {
    return languageDefs.map((def) => {
      const match = findSubtitleInEpisode(subtitles, def)
      const language = def.language || readSubtitleLanguageCode(match)
      const languageName =
        def.languageName ||
        (match && resolveSubtitleDisplayName(match)) ||
        '—'
      const langId = def.langId != null ? def.langId : match && match.langId
      return {
        language: language || '',
        languageName,
        langId,
        required: isEnglishSubtitleLang({ language, languageName, langId }),
        subtitleUrl: (match && match.subtitleUrl) || '',
        fileId: (match && match.fileId) || null
      }
    })
  }
  return subtitles.map((sub) => {
    const def = normalizeSubToLangDef(sub)
    return {
      ...def,
      subtitleUrl: sub.subtitleUrl || '',
      fileId: sub.fileId || null
    }
  })
}

export function mapMaterialsEpisodes(episodes, languageDefs) {
  const defs = languageDefs || []
  return (episodes || []).map((ep) => {
    const episodeNo = ep.seriesNum
    const subtitleList = (ep.subtitles || []).map((sub) => {
      const def = normalizeSubToLangDef(sub)
      return {
        language: readSubtitleLanguageCode(sub),
        languageName: def.languageName,
        subtitleUrl: sub.subtitleUrl || '',
        fileId: sub.fileId,
        langId: sub.langId,
        required: def.required
      }
    })
    const subtitleLangSlots = buildSubtitleLangSlots(ep, defs)
    const enTrack = (ep.subtitles || []).find((sub) =>
      isEnglishLanguage(sub.language)
    )
    return {
      episodeNo,
      title: (ep.title || '').trim() || `第${episodeNo}集`,
      coverUrl: ep.coverUrl || '',
      videoUrl: ep.videoUrl || '',
      posterFileId: ep.posterFileId || ep.coverFileId,
      rawFileId: ep.rawFileId,
      enSubtitleFileId:
        ep.englishSubtitleFileId ||
        (enTrack && enTrack.fileId) ||
        null,
      enSubtitleLangId: enTrack && enTrack.langId,
      subtitleList,
      subtitleLangSlots
    }
  })
}

const FILE_ACCEPT_MAP = {
  coverUrl: 'image/jpeg,image/jpg,image/png,image/webp',
  videoUrl: 'video/mp4,video/quicktime,.mp4,.mov'
}

const SUBTITLE_FILE_ACCEPT = '.srt,.vtt,text/plain'

export default {
  name: 'ViewProfileSingleList',
  props: {
    episodes: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    },
    /** 后端 materials 返回的外挂字幕语言配置 */
    subtitleLanguageDefs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandedEpisodes: [],
      episodeList: [],
      episodeListSnapshot: null,
      pendingFileEpisodeNo: null,
      pendingFileField: null,
      /** 单集必填项失焦校验：key 为 `${episodeNo}:${field}` */
      episodeFieldErrors: {}
    }
  },
  watch: {
    episodes: {
      handler(list) {
        this.rebuildEpisodeList(list)
      },
      immediate: true,
      deep: true
    },
    subtitleLanguageDefs: {
      handler() {
        this.rebuildEpisodeList(this.episodes)
      },
      deep: true
    },
    editable(val, oldVal) {
      if (val && !oldVal) {
        this.episodeListSnapshot = JSON.parse(JSON.stringify(this.episodeList))
      }
      if (!val && oldVal && this.episodeListSnapshot) {
        this.episodeList = JSON.parse(JSON.stringify(this.episodeListSnapshot))
        this.episodeListSnapshot = null
        this.episodeFieldErrors = {}
      }
    }
  },
  methods: {
    rebuildEpisodeList(list) {
      this.episodeFieldErrors = {}
      this.episodeList = mapMaterialsEpisodes(
        list,
        this.subtitleLanguageDefs
      )
      const maxNo = this.episodeList.length
        ? Math.max(...this.episodeList.map((item) => item.episodeNo))
        : 0
      this.expandedEpisodes = this.expandedEpisodes.filter((no) => no <= maxNo)
      if (!this.editable) {
        this.episodeListSnapshot = null
      }
    },
    subtitleSlotFieldKey(slot) {
      if (!slot) return ''
      const id =
        slot.langId != null && slot.langId !== ''
          ? String(slot.langId)
          : normalizeLanguageCode(slot.language)
      return `subtitleSlot:${id}`
    },
    getSubtitleSlotByFieldKey(item, field) {
      if (!item || !field || !field.startsWith('subtitleSlot:')) return null
      const key = field.slice('subtitleSlot:'.length)
      return (item.subtitleLangSlots || []).find((slot) => {
        if (slot.langId != null && String(slot.langId) === key) return true
        return normalizeLanguageCode(slot.language) === normalizeLanguageCode(key)
      })
    },
    isEpisodeExpanded(episodeNo) {
      return this.expandedEpisodes.includes(episodeNo)
    },
    toggleEpisode(episodeNo) {
      const index = this.expandedEpisodes.indexOf(episodeNo)
      if (index > -1) {
        this.expandedEpisodes.splice(index, 1)
      } else {
        this.expandedEpisodes.push(episodeNo)
      }
    },
    expandEpisode(episodeNo) {
      if (!this.isEpisodeExpanded(episodeNo)) {
        this.expandedEpisodes.push(episodeNo)
      }
    },
    scrollToEpisode(episodeNo) {
      this.$nextTick(() => {
        const wrap = this.$el && this.$el.querySelector('.episode-list-wrap')
        const item = this.$el && this.$el.querySelector(`[data-episode-no="${episodeNo}"]`)
        if (!wrap || !item) return
        const wrapRect = wrap.getBoundingClientRect()
        const itemRect = item.getBoundingClientRect()
        const offset = itemRect.top - wrapRect.top + wrap.scrollTop - 8
        wrap.scrollTop = Math.max(0, offset)
      })
    },
    displayFileLabel(url, emptyText = '') {
      const text = (url || '').trim()
      if (!text) return emptyText
      const segments = text.split(/[/\\]/)
      return segments[segments.length - 1] || text
    },
    /** 查看态字幕：有 URL 则展示完整地址（与送审视频一致） */
    displaySubtitleValue(url) {
      const text = (url || '').trim()
      return text || '—'
    },
    handleSelectFile(episodeNo, field) {
      const input = this.$refs.episodeFileInput
      if (!input) return
      this.pendingFileEpisodeNo = episodeNo
      this.pendingFileField = field
      input.accept =
        FILE_ACCEPT_MAP[field] ||
        (field && field.startsWith('subtitleSlot:')
          ? SUBTITLE_FILE_ACCEPT
          : '*')
      input.value = ''
      input.click()
    },
    handleFileChange(event) {
      const file = event.target.files && event.target.files[0]
      const episodeNo = this.pendingFileEpisodeNo
      const field = this.pendingFileField
      this.pendingFileEpisodeNo = null
      this.pendingFileField = null
      if (!file || episodeNo == null || !field) return

      const item = this.episodeList.find((ep) => ep.episodeNo === episodeNo)
      if (!item) return

      this.$set(item, field, `待上传：${file.name}`)
      if (!item._pendingLocalFiles) {
        this.$set(item, '_pendingLocalFiles', {})
      }
      this.$set(item._pendingLocalFiles, field, file)
      this.setEpisodeFieldError(episodeNo, field, '')
      this.$Message.success(`第${episodeNo}集已选择文件，确认送审时将上传并写入参数`)
    },
    applyUploadedFileToEpisode(item, field, fileId, fileUrl) {
      const id = Number(fileId)
      if (!id) return
      if (field === 'coverUrl') {
        this.$set(item, 'posterFileId', id)
      } else if (field === 'videoUrl') {
        this.$set(item, 'rawFileId', id)
      } else if (field && field.startsWith('subtitleSlot:')) {
        const slot = this.getSubtitleSlotByFieldKey(item, field)
        if (slot) {
          this.$set(slot, 'fileId', id)
        }
      }
      if (fileUrl) {
        this.$set(item, field, fileUrl)
      }
    },
    setEpisodeFieldUploading(item, field, uploading) {
      if (!item._uploadingFields) {
        this.$set(item, '_uploadingFields', {})
      }
      this.$set(item._uploadingFields, field, uploading)
    },
    uploadEpisodeField(item, field, file) {
      this.setEpisodeFieldUploading(item, field, true)
      return uploadReviewMaterialFile(file)
        .then(({ fileId, fileUrl }) => {
          this.applyUploadedFileToEpisode(item, field, fileId, fileUrl)
          if (item._pendingLocalFiles) {
            this.$delete(item._pendingLocalFiles, field)
          }
        })
        .finally(() => {
          this.setEpisodeFieldUploading(item, field, false)
        })
    },
    /** 确认送审前：将已选未传的文件上传，写入 posterFileId / rawFileId 等 */
    uploadPendingFiles() {
      const tasks = []
      this.episodeList.forEach((item) => {
        const pending = item._pendingLocalFiles || {}
        Object.keys(pending).forEach((field) => {
          const file = pending[field]
          if (file) {
            tasks.push(
              this.uploadEpisodeField(item, field, file).catch((err) => {
                const msg =
                  (err && err.message) || `第${item.episodeNo}集文件上传失败`
                return Promise.reject(new Error(msg))
              })
            )
          }
        })
      })
      if (!tasks.length) return Promise.resolve()
      return Promise.all(tasks)
    },
    hasPendingUploads() {
      return this.episodeList.some((item) => {
        const pending = item._pendingLocalFiles || {}
        return Object.keys(pending).length > 0
      })
    },
    hasEpisodeUploading() {
      return this.episodeList.some((item) => {
        const map = item._uploadingFields || {}
        return Object.keys(map).some((key) => map[key])
      })
    },
    episodeFieldErrorKey(episodeNo, field) {
      return `${episodeNo}:${field}`
    },
    getEpisodeFieldError(episodeNo, field) {
      if (!field) return ''
      return (
        this.episodeFieldErrors[this.episodeFieldErrorKey(episodeNo, field)] ||
        ''
      )
    },
    setEpisodeFieldError(episodeNo, field, message) {
      const key = this.episodeFieldErrorKey(episodeNo, field)
      if (message) {
        this.$set(this.episodeFieldErrors, key, message)
      } else if (this.episodeFieldErrors[key]) {
        this.$delete(this.episodeFieldErrors, key)
      }
    },
    /** 返回错误文案，通过则返回空字符串 */
    validateEpisodeFieldMessage(item, field) {
      if (!item || !field) return ''
      if (field === 'title') {
        const title = String(item.title == null ? '' : item.title).trim()
        return title ? '' : '请输入单集标题'
      }
      if (field === 'coverUrl') {
        return this.isEpisodeUrlFieldFilled(item, 'coverUrl', 'posterFileId')
          ? ''
          : '请填写或上传单集封面'
      }
      if (field === 'videoUrl') {
        return this.isEpisodeUrlFieldFilled(item, 'videoUrl', 'rawFileId')
          ? ''
          : '请填写或上传无字幕原片视频'
      }
      if (field.startsWith('subtitleSlot:')) {
        const slot = this.getSubtitleSlotByFieldKey(item, field)
        if (!slot || !slot.required) return ''
        return this.isSubtitleSlotFilled(item, slot)
          ? ''
          : `请填写或上传${slot.languageName}外挂字幕`
      }
      return ''
    },
    handleEpisodeFieldBlur(item, field) {
      if (!this.editable || !item) return
      if (field.startsWith('subtitleSlot:')) {
        const slot = this.getSubtitleSlotByFieldKey(item, field)
        if (!slot || !slot.required) {
          this.setEpisodeFieldError(item.episodeNo, field, '')
          return
        }
      }
      const msg = this.validateEpisodeFieldMessage(item, field)
      this.setEpisodeFieldError(item.episodeNo, field, msg)
    },
    handleEpisodeFieldInput(item, field) {
      if (!this.getEpisodeFieldError(item.episodeNo, field)) return
      const msg = this.validateEpisodeFieldMessage(item, field)
      if (!msg) {
        this.setEpisodeFieldError(item.episodeNo, field, '')
      }
    },
    /** 单集 URL 类字段：有 fileId、已选待传文件或有效链接即视为已填 */
    isEpisodeUrlFieldFilled(item, urlField, fileIdField) {
      if (pickPositiveInt(item[fileIdField])) return true
      const pending = item._pendingLocalFiles || {}
      if (pending[urlField]) return true
      const text = String(item[urlField] == null ? '' : item[urlField]).trim()
      if (!text || text === '—') return false
      return true
    },
    isSubtitleSlotFilled(item, slot) {
      if (!slot) return false
      if (pickPositiveInt(slot.fileId)) return true
      const fieldKey = this.subtitleSlotFieldKey(slot)
      const pending = item._pendingLocalFiles || {}
      if (fieldKey && pending[fieldKey]) return true
      const text = String(
        slot.subtitleUrl == null ? '' : slot.subtitleUrl
      ).trim()
      if (!text || text === '—') return false
      return true
    },
    /**
     * 单集四项必填：标题、封面、无字幕原片、英语外挂字幕
     * @returns {{ valid: boolean, message?: string, episodeNo?: number }}
     */
    validateRequiredEpisodeFields() {
      for (let i = 0; i < this.episodeList.length; i += 1) {
        const item = this.episodeList[i]
        const ep = item.episodeNo
        const checks = [
          { field: 'title', label: '单集标题' },
          { field: 'coverUrl', label: '单集封面' },
          { field: 'videoUrl', label: '无字幕原片视频' }
        ]
        for (let j = 0; j < checks.length; j += 1) {
          const { field } = checks[j]
          const msg = this.validateEpisodeFieldMessage(item, field)
          if (msg) {
            this.setEpisodeFieldError(ep, field, msg)
            return {
              valid: false,
              message: `第 ${ep} 集：${msg}`,
              episodeNo: ep
            }
          }
        }
        const requiredSubtitle = (item.subtitleLangSlots || []).find(
          (slot) => slot.required
        )
        if (requiredSubtitle) {
          const subField = this.subtitleSlotFieldKey(requiredSubtitle)
          const subMsg = this.validateEpisodeFieldMessage(item, subField)
          if (subMsg) {
            this.setEpisodeFieldError(ep, subField, subMsg)
            return {
              valid: false,
              message: `第 ${ep} 集：${subMsg}`,
              episodeNo: ep
            }
          }
        }
      }
      return { valid: true }
    },
    /** 供父组件确认送审时使用（仅业务字段，不含待传 File） */
    getEpisodeList() {
      return this.episodeList.map((item) => {
        const {
          _pendingLocalFiles,
          _uploadingFields,
          ...rest
        } = item
        return JSON.parse(JSON.stringify(rest))
      })
    },
    commitEditSnapshot() {
      this.episodeListSnapshot = JSON.parse(JSON.stringify(this.episodeList))
    }
  }
}
</script>

<style scoped>
.episode-list-wrap {
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.episode-list {
  padding-right: 8px;
  padding-bottom: 24px;
}

.episode-item {
  margin-bottom: 18px;
}

.episode-item:last-child {
  margin-bottom: 0;
}

.episode-item-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  height: 44px;
  padding: 0 14px;
  background: #f5f7fa;
  border: 1px solid #e8eaec;
  border-radius: 2px;
  cursor: pointer;
  user-select: none;
}

.episode-item-header:hover {
  background: #eef1f6;
}

/* 箭头与标题同一行高（20px），避免基线错位 */
.episode-item-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  line-height: 0;
  color: #606266;
  transition: transform 0.2s ease;
  transform-origin: 50% 50%;
}

.episode-item-arrow >>> .ivu-icon {
  display: block;
  font-size: 20px !important;
  line-height: 1;
}

.episode-item-arrow--expanded {
  transform: rotate(90deg);
}

.episode-item-title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  color: #303133;
  text-align: left;
}

.episode-item-body {
  padding: 18px 16px 20px;
  background: #fff;
  border: 1px solid #e8eaec;
  border-top: none;
  border-radius: 0 0 2px 2px;
}

.episode-item-header + .episode-item-body {
  margin-top: -1px;
}

.episode-form-row + .episode-form-row {
  margin-top: 18px;
}

.episode-field--cell {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.episode-field-label {
  flex: 0 0 auto;
  min-height: 20px;
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #909399;
}

.episode-field-control {
  flex: 0 0 auto;
}

.episode-field-error-tip {
  padding-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #ed4014;
}

.episode-field-control--error >>> .ivu-input {
  border-color: #ed4014;
}

.episode-field-control--error >>> .ivu-input:focus {
  border-color: #ed4014;
  box-shadow: 0 0 0 2px rgba(237, 64, 20, 0.2);
}

.episode-field-actions {
  flex: 0 0 auto;
  margin-top: 10px;
  min-height: 32px;
}

.episode-field-actions-placeholder {
  display: block;
  height: 32px;
}

.episode-required {
  margin-left: 2px;
  color: #ed4014;
}

.episode-label-optional {
  color: #909399;
  font-weight: normal;
}

.episode-field-value {
  font-size: 15px;
  line-height: 1.5;
  color: #303133;
}

.episode-field-value--file {
  word-break: break-all;
}

.episode-file-input {
  display: none;
}

.episode-item-body >>> .ivu-input {
  font-size: 14px;
}

.episode-item-body >>> .ivu-input-wrapper {
  width: 100%;
}

.episode-item-body >>> .ivu-input-wrapper .ivu-input {
  height: 38px;
  line-height: 20px;
  padding: 8px 10px;
}

.episode-item-body >>> .episode-upload-btn.ivu-btn {
  color: #2d8cf0;
  border-color: #2d8cf0;
  background-color: transparent;
  box-shadow: none;
}

.episode-item-body >>> .episode-upload-btn.ivu-btn:hover,
.episode-item-body >>> .episode-upload-btn.ivu-btn:focus {
  color: #57a3f3;
  border-color: #57a3f3;
  background-color: transparent;
}
</style>
